import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { getDisplayName } from '@grandvisionhq/utils';

function withAnchor(Component) {
    const displayName = getDisplayName(Component);
    const WithAnchor = (props)=>{
        const { page , component  } = props;
        const preview = page.isPreview();
        var ref;
        const { anchorId  } = (ref = component === null || component === void 0 ? void 0 : component.getParameters()) !== null && ref !== void 0 ? ref : {};
        return anchorId && anchorId !== '' && !preview ? /*#__PURE__*/ React.createElement("div", {
            className: "anchor-wrapper",
            id: anchorId,
            style: {
                marginTop: '-120px',
                paddingTop: '120px'
            }
        }, /*#__PURE__*/ React.createElement(Component, swcHelpers.extends({}, props))) : /*#__PURE__*/ React.createElement(Component, swcHelpers.extends({}, props));
    };
    WithAnchor.displayName = `withAnchor(${displayName})`;
    return WithAnchor;
}

export { withAnchor };
//# sourceMappingURL=with-anchor.js.map
